"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var GoogleRecaptcha = function GoogleRecaptcha(_ref) {
  var siteKey = _ref.siteKey,
      setIsABot = _ref.setIsABot;

  var onChange = function onChange() {
    if (siteKey) setIsABot({
      setIsABot: false
    });
  };

  return /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    sitekey: siteKey,
    onChange: onChange
  });
};

var _default = GoogleRecaptcha;
exports.default = _default;
GoogleRecaptcha.propTypes = {
  siteKey: _propTypes.default.string.isRequired,
  setIsABot: _propTypes.default.func.isRequired
};
GoogleRecaptcha.defaultProps = {};